import React from 'react'
import CircleIcon from '@mui/icons-material/Circle'

const ColoredDot = ({ color, size = 15 }) => {
  return <CircleIcon sx={{ color, fontSize: size, margin: '0.3rem' }} />
}

export default ColoredDot
